export function isRoundBalanced(
  areAllSaleLotQuantitiesBalanced,
  unpennedCount,
) {
  return areAllSaleLotQuantitiesBalanced && unpennedCount === 0;
}
